import { Box, Stack } from '@mui/material';
import React from 'react';
import MessageToast from '../../components/MessageToast';
import { StyledButton } from '../../components/styles/StyledButtons';
import StyledSection from '../../components/styles/StyledSection';
import { StyledHeading } from '../../components/styles/styles';
import AppPostEditor from './NewsAdmin/AppPostEditor';
import NewsAdminFormModal from './NewsAdmin/NewsAdminFormModal';
import NewsAdminImportModal from './NewsAdmin/NewsAdminImportModal';
import NewsAdminList from './NewsAdmin/NewsAdminList';
import { useNewsAdmin } from './NewsAdmin/useNewsAdmin';

const NewsAdmin: React.FC = () => {
  const news = useNewsAdmin();

  return (
    <Box sx={{ py: 3 }}>
      <StyledSection tone="tone1" noTopPadding>
        {news.formMode === 'app' ? (
          <AppPostEditor
            editing={news.editing}
            onClose={news.closeForm}
            onSaveDraft={news.saveAppPost}
            onPublish={news.publishAppPost}
            onShowToast={news.showToast}
          />
        ) : (
          <>
            <StyledHeading fullTopSpacing>News / Blog</StyledHeading>

            <Stack direction="row" spacing={2} sx={{ mt: '10px', mb: 2 }}>
              <StyledButton noTopSpacing onClick={() => void news.openImport()}>
                Import from website
              </StyledButton>
              <StyledButton noTopSpacing onClick={news.openAddAppPost}>
                Add post
              </StyledButton>
            </Stack>

            <NewsAdminList
              items={news.items}
              loading={news.loading}
              showArchived={news.showArchived}
              onToggleArchived={news.setShowArchived}
              onEdit={news.openEdit}
              onDelete={(item) => void news.archiveItem(item)}
              onUnarchive={(item) => void news.unarchiveItem(item)}
              onPublish={(item) => void news.publishItem(item)}
            />
          </>
        )}
      </StyledSection>

      <NewsAdminFormModal
        open={news.formMode === 'website'}
        editing={news.editing}
        onClose={news.closeForm}
        onSubmit={news.submitForm}
        onRefreshFromSource={news.refreshFromSource}
        onPublish={news.publishItem}
      />

      <NewsAdminImportModal
        open={news.importOpen}
        sourceUrl={news.sourceUrl}
        scanning={news.scanning}
        detected={news.detected}
        selectedRefs={news.selectedRefs}
        importing={news.importing}
        onClose={news.closeImport}
        onScan={() => void news.scan()}
        onToggleRef={news.toggleRef}
        onToggleAll={news.toggleAll}
        onImport={() => void news.importSelected()}
      />

      <MessageToast
        open={news.toast.open}
        message={news.toast.message}
        type={news.toast.type}
        onClose={news.closeToast}
      />
    </Box>
  );
};

export default NewsAdmin;
